import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'
import { enter, leave } from 'el-transition'
import hotkeys from 'hotkeys-js'

export default class extends Controller {
  static targets = ['folderTitle', 'modal', 'modalContainer']

  connect() {
    useClickOutside(this, { element: this.modalTarget })

    hotkeys(
      'escape',
      { scope: 'clients--folders--uploader-modal' },
      () => { this.hide() },
    )
  }

  clickOutside() {
    this.hide()
  }

  handleShowUploadModal({ detail: { folderId, folderTitle, modalId } }) {
    if (this.element.id === modalId) {
      this.folderTitleTarget.innerHTML = folderTitle
      this.dispatch('folderIdChanged', { detail: { folderId } })
      this.show()
    }
  }

  hide() {
    hotkeys.setScope('all')
    leave(this.modalContainerTarget)
    document.querySelector('body').classList.remove('overflow-hidden')
    this.dispatch('hide')
  }

  show() {
    hotkeys.setScope('global-documents-upload')
    enter(this.modalContainerTarget)
    document.querySelector('body').classList.add('overflow-hidden')
  }
}
